<section class="d-flex flex-column h-100">
  <p class="text-center">
    {{ 'wizards:tryRmm.rmm_final_rmm_description' | i18next }}
  </p>
</section>
